import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import OutlineTab from "./OutlineTab";
import FilterTab, { ReportFilter } from "./FilterTab";
import GraphTab from "./GraphTab";
import "./FilterPanel.scss";

type FilterPanelProps = {
  onApplyOutline: any;
  onResetOutline: () => void;
  selectedColumns: string[];
  setSelectedColumns: React.Dispatch<React.SetStateAction<string[]>>;
  groupColumns: string[];
  setGroupColumns: React.Dispatch<React.SetStateAction<string[]>>;
  groupRows: string[];
  setGroupRows: React.Dispatch<React.SetStateAction<string[]>>;
  appliedFilters: ReportFilter[];
  setAppliedFilters: React.Dispatch<React.SetStateAction<ReportFilter[]>>;
  chartSettings: any;
  setChartSettings: React.Dispatch<any>;
  hasTableData: boolean;
  tableColumns: { value: string; label: string }[];
  columnLabelMap?: Record<string, string>;
  readOnly?: boolean;
  disableInputs?: boolean;
};

const TAB_CONTENT = [
  {
    title: "Outline",
    description: "Configure your report structure",
  },
  {
    title: "Filters",
    description: "Configure your Filter Condition",
  },
  {
    title: "Chart Setting",
    description: "Configure your chart settings",
  },
];

const FilterPanel: React.FC<FilterPanelProps> = ({
  onApplyOutline,
  onResetOutline,
  selectedColumns,
  setSelectedColumns,
  groupColumns,
  setGroupColumns,
  groupRows,
  setGroupRows,
  appliedFilters,
  setAppliedFilters,
  chartSettings,
  setChartSettings,
  hasTableData,
  tableColumns,
  columnLabelMap,
  readOnly = false,
  disableInputs = false,
}) => {
  const [tab, setTab] = useState(0);

  return (
    <>
      <Tabs orientation="vertical" value={tab} onChange={(_, v) => setTab(v)}>
        <Tab label="Outline" />
        <Tab label="Filters" />
        <Tab label="Chart Setting" />
      </Tabs>

      <Typography className="rd-filter-title" variant="h6" component="h2" gutterBottom>
        {TAB_CONTENT[tab].title}
        <span className="rd-filter-panel__report-tag">Report</span>
      </Typography>

      <Typography className="rd-filter-description" gutterBottom>
        {TAB_CONTENT[tab].description}
      </Typography>

      <Box mt={3}>
        {tab === 0 && (
          <OutlineTab
            onApplyFilters={onApplyOutline}
            onResetFilters={onResetOutline}
            disabled={disableInputs || !hasTableData}
            readOnly={readOnly}
            selectedColumns={selectedColumns}
            setSelectedColumns={setSelectedColumns}
            groupColumns={groupColumns}
            setGroupColumns={setGroupColumns}
            groupRows={groupRows}
            setGroupRows={setGroupRows}
          />
        )}

        {tab === 1 && (
          <FilterTab
            selectedColumns={tableColumns}
            appliedFilters={appliedFilters}
            onApplyFilters={setAppliedFilters}
            onResetFilters={() => setAppliedFilters([])}
            readOnly={readOnly}
          />
        )}

        {tab === 2 && (
          <GraphTab
            selectedColumns={selectedColumns}
            chartSettings={chartSettings}
            setChartSettings={setChartSettings}
            disabled={disableInputs || !hasTableData}
            readOnly={readOnly}
            columnLabelMap={columnLabelMap}
          />
        )}
      </Box>
    </>
  );
};

export default FilterPanel;
